import { render, staticRenderFns } from "./CrmLeadDetailComment.vue?vue&type=template&id=ff712a7e&scoped=true&lang=pug&"
import script from "./CrmLeadDetailComment.vue?vue&type=script&lang=js&"
export * from "./CrmLeadDetailComment.vue?vue&type=script&lang=js&"
import style0 from "./CrmLeadDetailComment.vue?vue&type=style&index=0&id=ff712a7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff712a7e",
  null
  
)

export default component.exports